var $54b47fc030b7b21e$exports = {};
var $54b47fc030b7b21e$var$burger = document.querySelector(".burger");
var $54b47fc030b7b21e$var$burger_menu = document.querySelector(".burger_menu");
var $54b47fc030b7b21e$var$toggleMenu = function toggleMenu() {
    $54b47fc030b7b21e$var$burger_menu.classList.toggle("is-active");
    $54b47fc030b7b21e$var$burger.classList.toggle("is-active");
};
$54b47fc030b7b21e$var$burger.addEventListener("click", $54b47fc030b7b21e$var$toggleMenu);
document.addEventListener("DOMContentLoaded", ()=>{
    const loader = document.querySelector(".loader");
    setTimeout(()=>{
        loader.classList.add("hidden");
    }, 50);
});
const $54b47fc030b7b21e$var$boutonAjouterAuPanier = document.querySelector(".ajouter_au_panier");
let $54b47fc030b7b21e$var$quantite = 0;
$54b47fc030b7b21e$var$boutonAjouterAuPanier.addEventListener("click", ()=>{
    if ($54b47fc030b7b21e$var$quantite === 0) {
        $54b47fc030b7b21e$var$boutonAjouterAuPanier.innerHTML = `
      <button class="moins bouton quantity-controls">-</button>
      <span class="quantite bouton quantity-controls">${$54b47fc030b7b21e$var$quantite}</span>
      <button class="plus bouton quantity-controls">+</button>
    `;
        const boutonMoins = $54b47fc030b7b21e$var$boutonAjouterAuPanier.querySelector(".moins");
        const boutonPlus = $54b47fc030b7b21e$var$boutonAjouterAuPanier.querySelector(".plus");
        const affichageQuantite = $54b47fc030b7b21e$var$boutonAjouterAuPanier.querySelector(".quantite");
        boutonMoins.addEventListener("click", ()=>{
            if ($54b47fc030b7b21e$var$quantite > 0) {
                $54b47fc030b7b21e$var$quantite--;
                affichageQuantite.textContent = $54b47fc030b7b21e$var$quantite;
                if ($54b47fc030b7b21e$var$quantite === 0) {
                    $54b47fc030b7b21e$var$boutonAjouterAuPanier.innerHTML = "Ajouter au panier";
                    $54b47fc030b7b21e$var$boutonAjouterAuPanier.classList.remove("quantity-controls");
                }
            }
        });
        boutonPlus.addEventListener("click", ()=>{
            $54b47fc030b7b21e$var$quantite++;
            affichageQuantite.textContent = $54b47fc030b7b21e$var$quantite;
        });
    }
});


//# sourceMappingURL=index.72d060c4.js.map
